import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { EwalletService } from 'src/modules/features/admin/services/ewallet';
import {
  FundWalletModal,
  RequestWithdrawalModal,
  ViewDetailsModal,
  ChangeBankDetailsModal,
  CloseAccountModal,
  ExportStatementByDateModal,
} from 'src/modules/features/contractor/modals';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { formatNumber } from '@angular/common';
@Component({
  selector: 'app-account-sidebar',
  template: `
    <div class="account-card" [ngClass]="{ loading: pendingTwo }">
      <div class="card-heading">
        <p>NCC eWallet</p>
        <div>
          <span
            class="ui circular label"
            [ngClass]="{
              green: account?.status == 'ACTIVE',
              red: account?.status == 'INACTIVE'
            }"
            >{{ account?.status }}</span
          >
        </div>
      </div>
      <div
        class="ui basic segment account-card-balance"
        [ngClass]="{ loading: pending }"
      >
        <p class="account">
          {{
            account?.currencyShortName === 'DOLLAR'
              ? 'US Dollar'
              : (account?.currencyShortName | titlecase)
          }}
          account
        </p>
        <p class="balance">
          {{ account?.currencyCode
          }}{{
            account?.balance
              ? formatNumber(account?.balance, 2)
              : (0 | number: '1.2-2')
          }}
        </p>
        <p class="book-balance">
          Book Balance:
          <span class="amount"
            >{{ account?.currencyCode
            }}{{
              account?.bookBalance
                ? formatNumber(account?.bookBalance, 2)
                : (0 | number: '1.2-2')
            }}</span
          >
        </p>
        <p class="max-balance">
          Max Allowed Bal:
          <span class="amount"
            >{{ account?.currencyCode
            }}{{ formatNumber(account?.maximumWalletAmount, 0) || 5000 }}</span
          >
        </p>
      </div>
      <div class="ui basic primary dropdown" suiDropdown>
        <esl-button
          buttonType="primary"
          buttonSize="small"
          buttonState="outline"
          buttonActionState="default"
          [hasLine]="true"
          [hasSuffixIcon]="true"
          [buttonMenu]="'dropdownMenu'"
          [hasDropdown]="true"
          [isClickable]="true"
        ></esl-button>
        <div
          class="left menu actions-dropdown"
          style="right: 16px !important;"
          suiDropdownMenu
        >
          <div class="item" (click)="fundWallet()">Fund eWallet</div>
          <!-- <div class="item" (click)="requestWithdrawal()">
            Request Withdrawals
          </div> -->
          <!-- <div class="item" (click)="viewBankDetails()">View Bank Details</div>
          <div class="item" (click)="changeBankDetails()">
            Change Bank Details
          </div> -->
          <div class="item" (click)="exportStatement()">
            Export All Transactions Statement
          </div>
          <div class="item" (click)="exportStatementByDate()">
            Export Statement by Date
          </div>
          <div
            class="item close-item"
            style="text-transform: capitalize;"
            (click)="closeAccount()"
            *ngIf="account?.balance == 0"
          >
            Disable {{ account?.currencyShortName.toLowerCase() }} Account
          </div>
        </div>
      </div>
    </div>
    <div fxLayout="column" fxLayoutGap="10px">
      <div class="side-panel">
        <a
          *ngFor="let link of links"
          class="ui white button"
          fxLayout="row"
          routerLink="{{ link?.route }}"
          routerLinkActive="primary"
          appMargin
          marginY="8px"
          appPadding
          paddingY="14px"
        >
          {{ link?.name }}
        </a>
      </div>
    </div>
  `,
  styleUrls: ['./account-sidebar.component.scss'],
})
export class AccountSidebarComponent {
  error: any;
  filter = new AppFilter({
    sidx: 'walletCreatedDate',
    sord: 'asc',
    _search: false,
  });
  newFilter = new AppFilter({
    sidx: 'dateCreated',
    sord: 'asc',
    _search: false,
  });
  links = [
    {
      name: 'Transactions',
      route: '/contractor/wallet/transactions',
    },
    // {
    //   name: 'Withdrawal Requests',
    //   route: '/contractor/wallet/withdrawal-request',
    // },
    // {
    //   name: 'Bank Details Change Requests',
    //   route: '/contractor/wallet/bank-change-request',
    // },
  ];

  balance = 0;
  bookBalance = 0;
  maxBalance = 0;
  pending;
  pendingTwo;
  selectedCurrencyId; // set to route params
  companyName;
  walletStatus = 'DEFAULT';
  account;
  defaultCurrency = '₦';
  activeAccount;

  constructor(
    private modalService: SuiModalService,
    private walletService: EwalletService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    // setTimeout(()=>{this.selectedCurrencyId = localStorage.getItem('selectedCurrencyId')}, 0);
  }

  @Input() currencyId: string;

  ngOnInit(): void {
    this.filter = new AppFilter({ sidx: 'walletCreatedDate', sord: 'desc' });
    // setTimeout(()=>{
    this.route.params.subscribe((params) => {
      this.selectedCurrencyId = params['id'];
      if (this.selectedCurrencyId == 'dollar') {
        this.selectedCurrencyId = localStorage.getItem('usDollarId');
      }
    });
    this.getBalancesByCurrency();
    // }, 6000);
    this.companyName = JSON.parse(
      localStorage.getItem('user')
    ).organizationId.jpaContractor.companyName;

    this.links.forEach((item) => {
      item.route += `/${this.selectedCurrencyId}`;
    });
  }

  formatNumber(num: number, decimalDigits: number) {
    return formatNumber(
      Number(num),
      'en-US',
      `1.${decimalDigits}-${decimalDigits}`
    );
  }

  capitalize(word: string) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }

  exportStatement() {
    this.pending = true;
    this.walletService
      .exportEWalletTransactions({
        nccId: this.account.nccId,
        currencyId: this.account.currencyId,
        params: this.newFilter,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          const downloadLink = document.createElement('a');
          downloadLink.href = window.URL.createObjectURL(res);
          downloadLink.download = `eWallet ${this.capitalize(
            this.account.currencyShortName
          )} Statement ${new Date().toLocaleDateString('en-GB')}.xlsx`;
          downloadLink.click();
        },
        (error) => {
          this.error = error.error;
          this.pending = false;
        }
      );
  }

  fundWallet() {
    this.modalService.open(new FundWalletModal(this.account));
  }

  requestWithdrawal() {
    this.modalService
      .open(new RequestWithdrawalModal(this.account))
      .onApprove(() => {
        this.modalService
          .open(
            new ConfirmModal(
              'Withdraw Funds',
              'Your withdrawal request has been received and submitted successfully.',
              ModalSize.Tiny,
              'Okay',
              ''
            )
          )
          .onApprove(() => {
            if (
              this.router.url ==
              '/contractor/wallet/withdrawal-request/' + this.selectedCurrencyId
            ) {
              location.reload();
            } else {
              this.router.navigate([
                '/contractor/wallet/withdrawal-request',
                this.account.currencyId,
              ]);
            }
          });
      })
      .onDeny((openChangeBankDetails: boolean) => {
        if (openChangeBankDetails) {
          this.modalService.open(new ChangeBankDetailsModal(this.account));
        }
      });
  }

  viewBankDetails() {
    this.modalService.open(
      new ViewDetailsModal('View Bank Account Details', this.account)
    );
  }

  changeBankDetails() {
    this.modalService
      .open(new ChangeBankDetailsModal(this.account))
      .onApprove(() => {
        this.modalService
          .open(
            new ConfirmModal(
              'Change Bank Details',
              'Your bank details change request has been received and submitted successfully.',
              ModalSize.Tiny,
              'Okay',
              ''
            )
          )
          .onApprove(() => {
            localStorage.setItem(
              'customerWalletId',
              this.account.customerWalletId
            );
            if (
              this.router.url ==
              '/contractor/wallet/bank-change-request/' +
                this.selectedCurrencyId
            ) {
              location.reload();
            } else {
              this.router.navigate([
                '/contractor/wallet/bank-change-request',
                this.account.currencyId,
              ]);
            }
          });
      });
  }

  exportStatementByDate() {
    this.modalService.open(new ExportStatementByDateModal(this.account));
  }

  closeAccount() {
    if (!this.account) return;
    this.modalService
      .open(new CloseAccountModal(this.account))
      .onApprove((withdrawAllFunds: boolean) => {
        this.router.navigate(['/contractor/wallet/accounts'])
        // if (withdrawAllFunds) {
        //   this.modalService.open(
        //     new RequestWithdrawalModal(this.account, true)
        //   );
        // } else {
        //   this.modalService.open(
        //     new ConfirmModal(
        //       'Close Account',
        //       'Your request has been received and submitted successfully. Once approved, your account will be deactivated.',
        //       ModalSize.Tiny,
        //       'Okay',
        //       ''
        //     )
        //   );
        // }
      });
  }

  getBalancesByCurrency() {
    this.pending = true;
    this.pendingTwo = true;

    let filter = new AppFilter({
      sidx: 'walletCreatedDate',
      sord: 'desc',
      rows: 4000,
    });

    this.walletService
      .getBalancesByCurrency({
        currencyId: this.currencyId || this.selectedCurrencyId,
        params: filter,
      })
      .subscribe({
        next: (res: any) => {
          res?.rows.forEach((item) => {
            if (
              item.companyName === this.companyName &&
              item.currencyId === this.selectedCurrencyId
            ) {
              this.account = item;
              this.walletStatus = this.account?.status;
              this.pendingTwo = false;
              localStorage.setItem('customerWalletId', item?.customerWalletId);
            }
          });

          this.pending = false;
          // this.pendingTwo = false;
        },
        error: (error: any) => {
          console.log(error);
          this.pending = false;
          this.pendingTwo = false;
        },
      });
  }
}
